import React, {useContext} from 'react';
import Context from "../context";
import style from './main.module.css'

const IsLoginPanel = () => {
    const {logOut} = useContext(Context)

    const name =localStorage.getItem('name');
    const userRole = localStorage.getItem('type');
    const getRole = (role) => {
        switch (role) {
            case 'Admin':
                return 'Администратор';
            case 'Teacher':
                return 'Педагог';
                case 'Editor':
                return 'Редактор';
                case 'Student':
                return 'Учащийся';
                case 'Curator':
                return 'Координатор';
                case 'Expert':
                return 'Эксперт';
                case 'SuperExpert':
                return 'Супер-Эксперт';
            default:
                return role;
        }
    };

    const logout =()=>{
        logOut();
    }
    return (
        <div>
            <h1 className={style.nameText}>Добро пожаловать {name}</h1>
            <h2 className={style.roleText}>Роль пользователя: {getRole(userRole)}</h2>
            <div className={style.isLoginButtonWrapper}>
               <a href={'/profile'}><button className={style.buttonInfo}>Личный кабинет</button></a>
                <button className={style.buttonInfo} onClick={()=>logout()}>Выйти</button>
            </div>
        </div>
    );
};

export default IsLoginPanel;